import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const Auth0ProviderWithNavigate = ({ children }) => {
  const navigate = useNavigate();

  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audience = process.env.REACT_APP_API_GATEWAY;

  const onRedirectCallback = (appState) => {
    // If the user is impersonating, remove the impersonate token after login
    localStorage.removeItem('impersonate-token');

    navigate(appState?.returnTo || window.location.pathname);
  };

  if (!(domain && clientId)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience,
      }}
      onRedirectCallback={onRedirectCallback}
      // Use localStorage to provide persistence across page refreshes and browser tabs
      cacheLocation='localstorage'
      useRefreshTokens={false}
    >
      {children}
    </Auth0Provider>
  );
};
